import { useEffect, useState } from "react";

/**
 * NProgress-style top loading bar.
 * - 3px gold (#C9A84C) bar fixed at top
 * - Animates from 0% → 90% in 800ms ease-out on mount
 * - Jumps to 100% then fades out 200ms when unmounted (page loaded)
 * - No spinner, no text, no background overlay
 */
const TopProgressBar = () => {
  const [width, setWidth] = useState(0);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    // Trigger animation to 90% after mount
    const raf = requestAnimationFrame(() => setWidth(90));

    return () => {
      cancelAnimationFrame(raf);
      // Complete to 100% then fade — fire-and-forget DOM ops on unmount
      // (best-effort visual finish; React removes the node right after)
    };
  }, []);

  // When component is about to unmount, the parent removes it.
  // We rely on CSS transition for the entry animation; the exit is implicit (instant remove).
  // The 0→90% width transition gives the perceived "loading" feedback.

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: 9999,
        background: "transparent",
        pointerEvents: "none",
        opacity,
        transition: "opacity 200ms ease-out",
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${width}%`,
          background: "#C9A84C",
          boxShadow: "0 0 8px rgba(201, 168, 76, 0.5)",
          transition: "width 800ms ease-out",
        }}
      />
    </div>
  );
};

export default TopProgressBar;
